import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLine } from "@/components/Reveal";
import { FILTERS, PROJECTS } from "@/data/site";

export const Portfolio = () => {
  const [active, setActive] = useState("ALLE");
  const list = active === "ALLE" ? PROJECTS : PROJECTS.filter((p) => p.cat === active);

  return (
    <section id="portfolio" data-testid="portfolio" className="relative py-32 sm:py-48 border-t border-white/5">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-10">
        <Reveal><p className="label mb-6">Portfolio</p></Reveal>
        <h2 className="font-serif font-light text-5xl sm:text-7xl lg:text-8xl tracking-tight uppercase">
          <MaskLine>Selected Work</MaskLine>
        </h2>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-wrap gap-x-8 gap-y-3 border-b border-white/5 pb-6">
            {FILTERS.map((f) => (
              <button
                key={f}
                data-testid={`filter-${f}`}
                onClick={() => setActive(f)}
                className={`font-display uppercase tracking-[0.2em] text-xs pb-1 border-b transition-colors duration-300 ${
                  active === f ? "text-[#d4c4a8] border-[#d4c4a8]" : "text-[#71717a] border-transparent hover:text-[#fafafa]"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </Reveal>

        <motion.div layout className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <AnimatePresence mode="popLayout">
            {list.map((p) => (
              <motion.article
                layout
                key={p.id}
                data-testid={`project-${p.id}`}
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.98 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                className={`group relative ${p.span} col-span-1`}
              >
                <div className="img-zoom relative aspect-[4/3] lg:aspect-[16/10] border border-white/10">
                  <img src={p.img} alt={`${p.name} — ${p.client}`} loading="lazy" className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                  <ArrowUpRight className="absolute top-4 right-4 text-[#fafafa] opacity-0 group-hover:opacity-100 transition-opacity duration-500" size={22} strokeWidth={1.4} />
                  <div className="absolute bottom-0 left-0 p-6">
                    <p className="font-display uppercase tracking-[0.25em] text-[10px] text-[#d4c4a8] mb-2">{p.cat}</p>
                    <h3 className="font-serif text-3xl sm:text-4xl uppercase leading-none">{p.name}</h3>
                    <p className="mt-2 text-sm text-[#a1a1aa] max-w-md">{p.desc}</p>
                    <p className="mt-1 text-xs text-[#71717a]">{p.client}</p>
                  </div>
                </div>
              </motion.article>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};
